import { TableDataLineVentes } from '../../../components/organisms/Table/TableData/TableDataLineVentes';
import { TableData } from '../../../components/organisms/Table/TableData';
import React from 'react';
import { ElevesDashboardProf } from '../../../types/classe/maClasse';
import { GoToSinglePage } from '../../../helpers/page/goToPage';
import { WarningHeaderBlock } from 'components/molecules/Blocks/WarningHeaderBlock';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';

interface VentesTabProps {
  numberOfCommandePaymentReminder: number;
  eleves: ElevesDashboardProf[];
  toElevePage: GoToSinglePage;
}

const tabLabels = [
  'Nom complet',
  'CA (hors port)',
  'CA en attente (CB, Mandats, Virements)',
  'Ventes totales',
  'Ventes pro',
  'Ventes additionnelles',
  ''
];

export const VentesTab = ({
  eleves,
  toElevePage,
  numberOfCommandePaymentReminder
}: VentesTabProps) => {
  return (
    <>
      <FeatureContainer>
        {numberOfCommandePaymentReminder > 0 && (
          <WarningHeaderBlock
            variant="EspaceProf"
            numberOfOrders={numberOfCommandePaymentReminder}
          />
        )}
        <TableData tabLabels={tabLabels} noBackground>
          {eleves
            .sort((a, b) => a.lastname.localeCompare(b.lastname))
            .map(
              eleve =>
                eleve.note && (
                  <TableDataLineVentes
                    variant={
                      eleve.orderNeedToBeReminded > 0 ? 'warning' : 'default'
                    }
                    key={eleve.id}
                    eleve={eleve}
                    unPayedCa={eleve.unpayedCa}
                    toElevePage={() => toElevePage({ id: eleve.id })}
                  />
                )
            )}
        </TableData>
      </FeatureContainer>
    </>
  );
};
